import { render, staticRenderFns } from "./biRecordJoin.vue?vue&type=template&id=1018710e&scoped=true&"
import script from "./biRecordJoin.vue?vue&type=script&lang=js&"
export * from "./biRecordJoin.vue?vue&type=script&lang=js&"
import style0 from "./biRecordJoin.vue?vue&type=style&index=0&id=1018710e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018710e",
  null
  
)

export default component.exports